import React, {Fragment, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/HelpOutline';
import HomeIcon from '@material-ui/icons/Home';
import EmailIcon from '@material-ui/icons/Email';
import PaymentIcon from '@material-ui/icons/Payment';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import SettingsIcon from '@material-ui/icons/Settings';
import CodeIcon from '@material-ui/icons/Code';
import ListIcon from '@material-ui/icons/ListAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import SalesCoachIcon from '@material-ui/icons/School';
import ShareIcon from '@material-ui/icons/Share';
import {Popup, Subscription_addon_popup} from '../components';
import {connect} from 'react-redux';

const drawerWidth = 60;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    boxShadow:'10px 0 5px -2px #888',
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    boxShadow:'5px 0 5px -2px #888',
    width: drawerWidth,
    overflowX:'hidden'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function ResponsiveDrawer(props) {
  let pathname=props.history.location.pathname;
  //const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [force_list_view_filter, setForceListViewFilter]=useState(undefined); //USED IN JUMPSTART BACKEND TO SET DOWNLOAD VIEW AS DEFAULT VIEW;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [jumpstart_purchase_popup, setJumpStartPurchasePopup]=useState(false);
  const [open_jumpstart, setOpenJumpStart]=useState(false);

  let buttons=[];
  if(pathname.includes('/companies/table')==true){pathname='/companies/table';}
  let help_urls={
    '/companies/table':'https://prospectsafari.com/docs/user-guide/tutorials/new-user/',
    '/email/templates':'https://prospectsafari.com/docs/user-guide/communication/templates/',
    '/email/shortCodes':'https://prospectsafari.com/docs/user-guide/communication/short-codes/',
    '/email/sequences':'https://prospectsafari.com/docs/user-guide/communication/sequences/',
    '/team':'https://prospectsafari.com/docs/user-guide/tutorials/add-users/',
    '/blacklisted':'',
    '/setup':'https://prospectsafari.com/docs/user-guide/settings/',
    '/integrations':'https://prospectsafari.com/docs/user-guide/integrations/',
    '/payments/active':'',
    '/payments/analytics':'',
    '/payments/history':'',
    '/sales_coach/setup':'https://prospectsafari.com/docs/user-guide/tutorials/manage-a-deal/',
    '/sales_coach/documents':'https://prospectsafari.com/docs/user-guide/tutorials/manage-a-deal/',
    '/sales_coach/checklists':'https://prospectsafari.com/docs/user-guide/tutorials/manage-a-deal/',
    '/sales_coach/quizzes':'https://prospectsafari.com/docs/user-guide/tutorials/manage-a-deal/',
  }
  let current_help_url=help_urls[pathname];
  if(current_help_url==undefined){
    for(let key in help_urls){if(pathname.includes(key)==true){current_help_url=help_urls[key];}}
  }


  if(isScoringAccount(props.workspace)==true){current_help_url='https://docs.google.com/document/d/1exjoOAIfTO_Hy2gRjRwph42EySf1QT6BxDT_GJfxnTM/preview?pli=1';}
  console.log(props.workspace,' WORKSPACE')
  if(isScoringAccount(props.workspace)==true && props.workspace!=undefined && props.workspace.special_services!=undefined){for(let ss of props.workspace.special_services){let saved_f; if(ss.saved_filter_id!=undefined && props.saved_filters!=undefined){for(let sf of props.saved_filters){if(sf.id==ss.saved_filter_id){saved_f=sf;}}} if(saved_f!=undefined && force_list_view_filter==undefined){setForceListViewFilter(saved_f.path); props.history.push(saved_f.path);}}} //SETS DEFAULT VIEW IF NECESSARY AND CHANGES CURRENT VIEW.
  let all_buttons=[
    {no_jumpstart_backend:true, label:'Home', icon:<HomeIcon color='secondary'/>, url:'/home'},
    {label:'Lists', icon:<ListIcon color='secondary'/>, url:(force_list_view_filter!=undefined)?force_list_view_filter:(props.last_url!=undefined && props.last_url!='wait')?props.last_url:'/companies/table'},
    {no_jumpstart_backend:true, label:'Communications', icon:<EmailIcon color='secondary'/>, url:'/email/templates'},
    {no_jumpstart_backend:true, label:'Sales coach', icon:<SalesCoachIcon color='secondary'/>, url:'/sales_coach/setup', admin_only:true},
    {no_jumpstart_backend:true, label:'Payments', icon:<PaymentIcon color='secondary'/>, url:'/payments/active', admin_only:true, not_free_account:true},
    {no_jumpstart_backend_non_admin:true, label:'Team', admin_only:true, icon:<PeopleAltIcon color='secondary'/>, url:'/team'},
    {no_jumpstart_backend:true, label:'Blacklisted', icon:<DeleteIcon color='secondary'/>, url:'/blacklisted'},
    {no_jumpstart_backend:true, label:'Settings', icon:<SettingsIcon color='secondary'/>, url:'/setup'},
    {no_jumpstart_backend:true, label:'Integrations', icon:<CodeIcon color='secondary'/>, url:'/integrations'},
    {label:'Clients', icon:<ShareIcon color='secondary'/>, url:'/defaults', default_access_only:true},
    {label:'Help', icon:<HelpIcon color='secondary'/>, url:current_help_url}
  ];
  let scoring_on=false;
  if(props.workspace!=undefined){
    for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.rec=='SCORING'){scoring_on=true;} all_buttons.unshift({label:ss.name, description:ss.description, icon:<img style={{width:'23px'}} src={ss.logo}/>, url:'/spesc/'+ss.name});}}
  }
  //let jumpstart_subscription=undefined;
  //if(props.subscriptions!=undefined && props.workspace!=undefined && props.workspace.active_subscription!=undefined){
  //  let main_product=undefined; for(let s of props.subscriptions){if(s.id==props.workspace.active_subscription.prospect_safari_service_id){main_product=s;}}
  //  for(let s of props.subscriptions){
  //  if(s.subscription_interval==main_product.subscription_interval && s.rec=='PRL'){jumpstart_subscription=s;}
  //}}

  if(scoring_on==false && props.workspace!=undefined){
    all_buttons.unshift({marketing_on:!props.me.scoring_marketing, label:'JumpStart', description:'Have your leads scored and save days of hard work', icon:<img style={{width:'23px'}} src='/images/icons/scoring_service.png'/>, onClick:()=>{setOpenJumpStart(true);}});
  }
  console.log(all_buttons, 'ALL BUTTONS', 'WOOOOOORKSPACESSS');

  for(let ab of all_buttons){if(((props.workspace!=undefined && ((props.workspace.admin==true && ab.admin_only==true) || (props.workspace.user_id==props.me.id && ab.owner_only==true))) || (ab.admin_only!=true && ab.owner_only!=true)) && (ab.not_free_account!=true || (props.workspace!=undefined && ab.not_free_account==true && props.workspace.free_account!=true))){buttons.push(ab)}}
  let new_buttons=[]; for(let b of buttons){
    if((b.sales_coach!=true || (props.workspace!=undefined && (props.workspace.sales_coach==true || props.workspace.superuser==true))) && (b.default_access_only!=true || (props.workspace!=undefined && props.workspace.default_access==true)) && (isScoringAccount(props.workspace)!=true || b.no_jumpstart_backend!=true) && (isScoringAccountNonAdmin(props.workspace, props.me)!=true || b.no_jumpstart_backend_non_admin!=true)){new_buttons.push(b);}
  } buttons=new_buttons;
  console.log(props.workspace, 'WORKSPACE', buttons);
  const drawer = (
    <div>
      <div style={{marginTop:'50px'}}/>
      <List>
        {buttons.map((b, index) =>{
          return(
            <ListItem button key={b.url} onClick={()=>{if(b.onClick!=undefined){b.onClick();}else if(b.label=='Help'){open(b.url, 'help_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0');}else{props.history.push(b.url)}}}>
              <Tooltip title={(b.description!=undefined)?b.description:b.label} aria-label="add">{(b.marketing_on!=true)?<ListItemIcon>{b.icon}</ListItemIcon>:<div className='marketing_new_feature_side_menu'><ListItemIcon>{b.icon}</ListItemIcon></div>}</Tooltip>
            </ListItem>
          );
          })}
      </List>
    </div>
  );
  const container=undefined;
  //const container = window !== undefined ? () => window().document.body : undefined;


  return (
    <Fragment>
      <nav style={{backgroundColor:'white'}} className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            PaperProps={(mobileOpen==true)?{id:'lv_wiz_1'}:{}}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            PaperProps={(mobileOpen==true)?{}:{id:'lv_wiz_1'}}
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      {(open_jumpstart==false)?null:
        <Popup accept_button={'Purchase'} accept_button_click={()=>{window.location.href='/payments/subscriptions';}} handleClose={()=>{setOpenJumpStart(false)}} always_open title={'JumpStart (team subscription required)'} content={
          <div style={{width:'90vw', maxWidth:'600px', height:'400px', marginTop:'30px', marginBottom:'30px'}}>
          <div><img style={{maxWidth:'300px', marginLeft:'10px', marginTop:'-10px'}} src='/images/icons/scoring_service_biggest.png'/></div>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
          <Typography style={{fontWeight:"bold", marginTop:'20px'}}>Give yourself a <a href='https://prospectsafari.com/jumpstart/'>JumpStart</a>: </Typography>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - <b>7x</b> your call connect rate</Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - <b>7x</b> more actual conversations per hour spent dialling</Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - Slash your cost per meeting and boost your Return on Sales Time (ROST).</Typography></div>
          <div><Typography style={{fontWeight:"bold", marginTop:'20px'}}>How does it work? </Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - Activate a TEAM Subscription.</Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - Bulk select and request scoring of selected contacts</Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - We identify the best phone number & determine the likelihood of an answer</Typography></div>
          <div><Typography variant='caption' style={{marginLeft:'30px'}}> - You call only those likely to answer. Use email, social etc for the rest.</Typography></div>
          <div style={{marginTop:'20px'}}><Typography variant='caption'><b>Cost: $1 per contact</b> (up to 5 phone numbers each).</Typography></div>
          <div><Typography variant='caption'>Credits purchased in packs of 50.</Typography></div>
          <div><Typography variant='caption' style={{color:'red'}}>* Only numbers from north america are supported.</Typography></div>
          <div><Typography variant='caption'><a href='https://prospectsafari.com/jumpstart/'>Not convinced? Click here</a></Typography></div>
        </div></div>}/>}
      </Fragment>
  );
}
//{(jumpstart_subscription==undefined || jumpstart_purchase_popup!=true)?null:<Subscription_addon_popup {...props} ps={jumpstart_subscription} handleClose={()=>{setJumpStartPurchasePopup(undefined); setOpenJumpStart(false);}}/>}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default connect(ss)(ResponsiveDrawer);


function ss(state){
  return{
    me:state.account.me,
    last_url:state.account.last_url,
    subscriptions:state.account.subscriptions,
    saved_filters:state.saved_filters.data,
  }
}
